import { ReactNode } from "react";
import { ChartLegendItem } from "@uicore";

export const AI_SERVICES_OTHER_TOOLTIP =
  "Billed by Snowflake under AI Services but not itemized to a specific Cortex service, so these costs can't be attributed individually.";

// Recharts `<Legend formatter>` for the AI Services breakdown: render each
// legend label, attaching the info tooltip to the unattributable
// `ai_services_other` residual series. Defined as a referenced function (not an
// inline arrow) so it is unit-testable — recharts doesn't invoke the formatter
// under jsdom.
export const aiServicesLegendFormatter = (
  value: string,
  entry?: { dataKey?: unknown }
): ReactNode => (
  <ChartLegendItem
    label={value}
    tooltip={
      String(entry?.dataKey ?? "") === "ai_services_other" ? AI_SERVICES_OTHER_TOOLTIP : undefined
    }
  />
);
